export default __webpack_public_path__ + "images/header-bg.png?32e7e2750c06389f17205a07f83513a1";